import { MouseEvent } from "react";

export type ColElement = {
  class?: string;
};

export type StripType = {
  title: string;
  body: string;
};

export type EventInfoType = {
  label: string;
  text: string;
};

export type SidebarTicketType = {
  id?: string;
  type: string;
  price: number | 0;
  num: number | 0;
};

export type SidebarEventType = {
  name: string;
  time?: string;
  tickets?: SidebarTicketType[] | never;
};

export type ButtonType = {
  id?: string;
  btnHref?: string;
  btnClass: string;
  disabled?: boolean | undefined;
  ariaLabel?: string | undefined;
  btnType?: "submit" | "reset" | "button";
  linkType?: "link" | "exlink"; // link -> internal links , exlink -> external links
  btnClick?: (e: MouseEvent<HTMLButtonElement>) => void;
};

export type QuantitySelectorType = {
  min: number | 0;
  max: number | 0;
  current: number | 0;
  ticketID: number;
};

export type StepType = {
  step: number;
  urlCode: string;
};

export type PanelsType = {
  active?: "on" | "off" | "";
};

export type TicketDataType = {
  membershipOffer: boolean;
  discount: number;
  totalTickets: number;
};

type contactDetails = {
  title: string;
  first_name: string;
  last_name: string;
  email: string;
  postcode: string;
  mobile_number: string;
  membership_number: string;
  country: string;
  enews: "on" | "";
};

export type timeType = {
  perfID: string;
  time: string;
  text: string;
  spotLeft: number;
  available: boolean;
  selected: "" | "on";
};

export type timeGroupsType = {
  code: string;
  name: string;
  error: "" | "on";
  times: timeType[];
};

export type datesType = {
  moment: any;
  text: string;
};

export enum VoucherTypes {
  DISCOVER = "CSG",
  PARENTS = "CSP",
}

export type fullOrderType = {
  dates: datesType[];
  membershipOffer: boolean;
  donation: number;
  donationAk: string;
  dndVoucher: string;
  dndVoucherValue: number;
  dndVoucherType: VoucherTypes;
  fullTimePerfID: string;
  discountSection: boolean;
  discount: number;
  discountCode: string;
  totalTickets: number;
  totalFee: number;
  ticketType: string;
  date: string;
  avaTimes: timeType[];
  avaTimeGroups: timeGroupsType[];
  upsells: any[];
  upsellCode: string;
  saleak: string;
  people: any[];
  peopleAK: any[];
  event: EventType;
  contactDetails: contactDetails;
  terms: boolean;
  eventLists: string[];
};

export type EventType = {
  id: string;
  name: string;
  date: any;
  time: string;
  perfID: string;
  totalTickets: number;
  stepOne: "on" | "off" | "";
  stepTwo: "on" | "off" | "";
  stepThree: "on" | "off" | "";
  tickets: ticketType[];
};

export type titleType = {
  code: string;
  description: string;
};

export type countryType = {
  code: string;
  description: string;
};

export type ticketType = {
  id: string;
  ak: string;
  code: string;
  name: string;
  type: string;
  category: string;
  sheetname: string;
  description: string;
  price: number;
  num: number;
  details: any;
};
